import * as Factory from 'factory.ts'
import faker from 'faker'

import { AttachmentTypes, LoggerActions } from '@webapp/models/enums'
import {
  type PurchaseOrderLineItemV2,
  type PurchaseOrderLineItemV2Attachment,
} from '@webapp/models/PurchaseOrderLineItemV2'
import { ApprovalHistoryMock } from './approvalHistory.factory'
import { OneTimeOrderItemMock } from './orderItem.factory'
import { SimpleUserMock } from './user.factory'

export const PurchaseOrderLineItemV2Mock =
  Factory.Sync.makeFactory<PurchaseOrderLineItemV2>({
    ...OneTimeOrderItemMock.build(),
    flags: null,
    attachments: [],
    receive_log_count: 0,
    receivedFailQty: 0,
    receivedPassQty: 0,
    approval_history: [
      ApprovalHistoryMock.build({ action: LoggerActions.REQUEST }),
      ApprovalHistoryMock.build({ action: LoggerActions.APPROVE_AND_PASS_ON }),
      ApprovalHistoryMock.build({ action: LoggerActions.FINAL_APPROVE }),
    ],
    purchaser: null,
    requester: SimpleUserMock.build(),
  })

export const PurchaseOrderLineItemV2AttachmentMock =
  Factory.Sync.makeFactory<PurchaseOrderLineItemV2Attachment>({
    id: Factory.each(() => faker.random.number()),
    attachment: Factory.each(() => `attachments_${faker.random.uuid()}`),
    upload_datetime: faker.date.past().toISOString(),
    name: Factory.each(
      (index) => `attachment_${index}_${faker.system.commonFileName('png')}`
    ),
    type: AttachmentTypes.PACKING_SLIP,
    user: Factory.each(() => faker.random.number()),
    item: Factory.each(() => faker.random.number()),
  })
